import { motion } from "framer-motion";
import { FEATURES } from "@/data/content";
import { ICONS } from "@/components/icons";

export default function Features() {
  return (
    <section id="features" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#3B82F6]">Why Radio App Consultancy</p>
        <h2 className="font-display text-3xl sm:text-4xl tracking-tight mt-3 max-w-4xl uppercase leading-[0.95]" data-testid="features-heading">
          Independent software studio.{" "}
          <span className="text-[#3B82F6]">One-time delivery that just works.</span>
        </h2>
        <p className="text-[#475569] mt-6 max-w-2xl leading-relaxed">
          Radio App Consultancy is an independent consultancy — we give expert consultation and
          design, build and ship your product for a single one-time project charge. No subscription, ever.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="rounded-xl bg-white border border-[#E2E8F0] p-8 hover:border-[#3B82F6] hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
                data-testid={`feature-card-${i}`}
              >
                <span className="h-12 w-12 rounded-lg bg-[#26395F] flex items-center justify-center mb-5">
                  <Icon className="h-5 w-5 text-[#3B82F6]" />
                </span>
                <h3 className="font-display text-xl tracking-tight uppercase">{f.title}</h3>
                <p className="text-sm text-[#475569] mt-3 leading-relaxed">{f.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
